import React, { useEffect, useState } from 'react'
import Summary from './Summary/Summary'
import History from './History/History'
import PastEncounters from './PastEncounters/PastEncounters'
import { ServerRequestProtected, ServerRequestProtectedWithoutToken } from '../../../../../utils/ServerDataRequest'
import isNull from '../../../../../utils/NullChecking'
import { enumUtil } from '../../../../../utils/Enum'
import { useSelector } from 'react-redux'
import Loader from '../../../../shared/Loader/Loader'
import { useDispatch } from 'react-redux'
import { FindFirstChild } from '../../../../../utils/FindMenuOption'

const ClinicalSummary = (props) => {
    let { patientID } = props;
    let IsEditAllowed = FindFirstChild('Patient', 'Clinical Summary')?.IsAdd
    console.log("patientID patientID", patientID)
    // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id;
    let activePatTab = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    let dispatch = useDispatch();
    
    const API_URL = enumUtil.controller.PatientEncounter
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([])
    const [isRecordSaved, setIsRecordSaved] = useState(false)
    const LoadData = () => {
        setData([])
        setIsRecordSaved(false);
        setIsLoading(true);
        ServerRequestProtectedWithoutToken(API_URL + "/GetSummaryData", 'post', {
            "ID": patientID,
            "TableName": enumUtil.enumAPITableName.PatientProblemList,
        })
            .then((response) => {
                setIsLoading(false);
                setData(response);
            }).catch((error) => {
                setIsLoading(false);
            })
    }

    useEffect(() => {
        console.log("prop reload Encounter Clinical")
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 211) {
                    LoadData()
                }
            })
            if (data.length === 0) {
                LoadData()
            }
        }
    }, [props.Reload])

    useEffect(() => {
        LoadData();
    }, [isRecordSaved])


    const handleOpenEncounter = () => {
        if(!IsEditAllowed) return;
          dispatch({
            type: 'OPEN_PATIENT_WITH_ENCOUNTER_TAB',
            payload: {
              patientTab: activePatTab,
              encounterTab: {
                active: true,
                key: 2,
                name: "Encounter",
                data: {
                  id: 0, name: "All Encounter", time: new Date(),
                  AddEncounterPopup: {
                    active: true,
                    data: {
                        Action:'ApplyDemoData',
                    }
                  }
                },
              }
            }
          });
    
        }
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-1 clinical-top pe-4 me-2">
                <p className="heading">
                    {/* Wednesday, Jul 14, 2021 */}
                </p>
                <div className="d-flex align-items-center gap-2">
                    <div className="br-right-1 br-clr pe-2 d-flex">
                        <span class="icon-Group-1000002858 fs-21"><span class="path1"></span><span class="path2"></span></span>
                    </div>
                    <button className={`btn btn-orange btn-xs no-width rounded mb-0 d-flex align-items-center gap-1 ${IsEditAllowed ? '' : 'disable'}`} onClick={() => handleOpenEncounter()}>
                        <span className="fs-16 heading text-white">+</span>Create New Encounter
                    </button>
                </div>
            </div>
            <div className="Clinical_Summary d-flex px-1-5">
                {isLoading ? <Loader /> : <></>}
                <div className="col-md-4 mb-06-px pe-1-5">
                    <Summary expandAll={true} data={data} setIsRecordSaved={setIsRecordSaved} patientID={patientID} />
                </div>
                <div className="col-md-4 mb-06-px pe-1-5">
                    {/* <History /> */}
                    <History expandAll={true} {...props} patientID={patientID} />
                </div>
                <div className="col-md-4 mb-06-px">
                    <PastEncounters  {...props} patientID={patientID} />
                </div>
            </div>
        </div>

    )
}

export default ClinicalSummary